export default {"src":"/_next/static/media/check-circle.ef85f3ff.svg","height":21,"width":21};